import {
    DocumentationEvent,
    Event,
    isDocumentationEventType
} from '@tadpoles/common'
import { type StaticDecode, Type } from 'typebox'
import { Value } from 'typebox/value'

import type {
    DecodeOnlyPersistenceCollectionDefinition,
    PersistenceCollection
} from '@tadpoles/persistence'

const EventCollectionSchema = Type.Union([
    DocumentationEvent,
    Event
])
export type EventRecord = StaticDecode<typeof EventCollectionSchema>
export type FamilyEventStore = PersistenceCollection<EventRecord, 'key'>

export const EventCollectionDefinition: DecodeOnlyPersistenceCollectionDefinition<
    typeof EventCollectionSchema,
    EventRecord,
    'key'
> = {
    kind: 'event',
    scope: 'user',
    primaryKey: 'key',
    modelSchema: EventCollectionSchema,
    indexes: ['type', 'eventTime'],
    decode: (value) => {
        if (isDocumentationEventType(value.type)) {
            return Value.Decode(DocumentationEvent, value)
        }

        return Value.Decode(Event, value)
    }
}
